import Switch from '@mui/material/Switch';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PageLoader from '../../../components/loaders/PageLoader';
import { GET, PUT } from '../../../services/rest.service';
const Settings = () => {
  const [sitter, setSitter] = useState(null);
  const [topNannies, setTopNannies] = useState(null);
  const [isReady, setIsReady] = useState(false);

  const getAppConfiguration = async () => {
    try {
      const { data } = await GET('/admin/appConfiguration');
      setSitter(data.configuration.sitter);
      setTopNannies(data.configuration.topNannies);
      setIsReady(true);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getAppConfiguration();
  }, []);

  const toggleSwitch = async (record) => {
    record = record ? false : true;

    try {
      await PUT(`/admin/appConfiguration`, { sitter: record, topNannies: topNannies });
      setSitter(record);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const toggleSwitchNannies = async (record) => {
    record = record ? false : true;

    try {
      await PUT(`/admin/appConfiguration`, { topNannies: record, sitter: sitter });
      setTopNannies(record);
    } catch (err) {
      toast.error(err.message);
    }
  };

  if (!isReady) {
    return <PageLoader />;
  }

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row mb-4">
          <div className="col-xl-3 col-lg-6 mb-4 mb-xl-0 c-pointer">
            <div className="bg-white shadow roundy p-4 h-100 d-flex align-items-center justify-content-between">
              <div className="flex-grow-1 d-flex align-items-center">
                <div className="dot mr-3 bg-violet"></div>
                <div className="text">
                  <h6 className="mb-0">Sitter Platform</h6>
                </div>
              </div>
              <Switch color="secondary" onClick={() => toggleSwitch(sitter)} checked={sitter === true} />
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 mb-4 mb-xl-0 c-pointer">
            <div className="bg-white shadow roundy p-4 h-100 d-flex align-items-center justify-content-between">
              <div className="flex-grow-1 d-flex align-items-center">
                <div className="dot mr-3 bg-green"></div>
                <div className="text">
                  <h6 className="mb-0">Top Nannies</h6>
                </div>
              </div>
              <Switch color="secondary" onClick={() => toggleSwitchNannies(topNannies)} checked={topNannies === true} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Settings;
